export const baseUrl = 'https://api.themoviedb.org/3'

export const API_KEY = "414746bba6c84ffae8d0cec9255af00c"

export const imageUrl = 'https://image.tmdb.org/t/p/original'